const appConfig = {
    //  apiPrefix: 'http://localhost:7069/api/',
    //  apFilePrefix: 'http://localhost:7069/',
    apiPrefix: 'https://api.complianceguru.co.in/api/',
    apFilePrefix: 'https://api.complianceguru.co.in/',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig